module.exports = __webpack_public_path__ + "static/media/starry-sky.8b467bf6.jpeg";